import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SvbrgCategoryType } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';

type StatusColor = 'success' | 'error' | 'warning' | 'info' | 'primary' | 'secondary';

const agentGroupIconColorMap: Record<SvbrgCategoryType, StatusColor> = {
  [SvbrgCategoryType.SOURCING]: 'primary',
  [SvbrgCategoryType.CONVERSATION]: 'info',
  [SvbrgCategoryType.INTAKE]: 'success',
};

export const FilterChip = ({
  agent,
  active,
  onClick,
}: {
  agent: SvbrgCategoryType;
  active: boolean;
  onClick: () => void;
}) => {
  const { t } = useTranslation(I18nNamespace.cockpit);
  const color = agentGroupIconColorMap[agent];
  const action = active ? 'hide' : 'show';

  const title = t(`AgentCategory.${agent}.name`);
  const tooltipTilte = t(`AgentPanel.actions.${action}`, { category: title });
  return (
    <Tooltip title={tooltipTilte} placement="top" arrow>
      <Chip
        sx={{
          flexGrow: 0,
          flexShrink: 1,
          flexBasis: 'auto',
          minWidth: 0,
        }}
        label={title}
        color={active ? color : 'default'}
        variant={active ? 'filled' : 'outlined'}
        onClick={onClick}
        clickable
      />
    </Tooltip>
  );
};
